define ['./notifications.scss'], () ->
  ($http, $scope, RENTAPPLICATION_API_URL, $timeout, notifications) ->
    $scope.notifications = notifications.objects
    $scope.total_count = notifications.meta.total_count
    $scope.pagination_options = {}


// WEBPACK FOOTER //
// ./components/dashboard/notifications/notifications.coffee